import React from "react";

import "./css/ContactPage.css";
import ovi from "./images/ovi.PNG";

const contacts = [
  {
    label: "Email",
    value: "ovidiu.mura@yahoo.com",
    href: "mailto:ovidiu.mura@yahoo.com",
  },
  {
    label: "Phone",
    value: "(971) 990-9319",
    href: "tel:9719909319",
  },
  {
    label: "Location",
    value: "Portland, Oregon, United States · Remote",
  },
  {
    label: "LinkedIn",
    value: "linkedin.com/in/ovidiu-m-200573107",
    href: "https://www.linkedin.com/in/ovidiu-m-200573107",
  },
  {
    label: "GitHub",
    value: "github.com/ovimura",
    href: "https://github.com/ovimura",
  },
  {
    label: "Resume",
    value: "View formatted resume",
    href: "/resume",
  },
];

export default function ContactPage() {
  return (
    <div className="wrapper-contacts">
      <h1 className="title">Contact</h1>
      <div className="content">
        <div className="contact-layout">
          <img src={ovi} alt="Ovidiu Mura" className="img-ovi" />
          <ul className="contact-list">
            {contacts.map((item) => (
              <li key={item.label}>
                <span className="contact-label">{item.label}</span>
                {item.href ? (
                  <a href={item.href} target={item.href.startsWith("http") ? "_blank" : undefined} rel="noreferrer">
                    {item.value}
                  </a>
                ) : (
                  <span>{item.value}</span>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
